module.exports = __webpack_public_path__ + "static/img/rendering.133b4a2.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/rendering.jpg
// module id = r+2o
// module chunks = 0